export const timezoneAbbreviations: Record<string, string> = {
  "Pacific/Midway": "SST",
  "Pacific/Pago_Pago": "SST",
  "America/Adak": "HST",
  "Pacific/Honolulu": "HST",
  "America/Anchorage": "AKST",
  "America/Juneau": "AKST",
  "America/Metlakatla": "AKST",
  "America/Nome": "AKST",
  "America/Sitka": "AKST",
  "America/Yakutat": "AKST",
  "America/Los_Angeles": "PST",
  "America/Tijuana": "PST",
  "America/Vancouver": "PST",
  "America/Boise": "MST",
  "America/Cambridge_Bay": "MST",
  "America/Chihuahua": "CST",
  "America/Creston": "MST",
  "America/Dawson": "MST",
  "America/Dawson_Creek": "MST",
  "America/Denver": "MST",
  "America/Edmonton": "MST",
  "America/Fort_Nelson": "MST",
  "America/Hermosillo": "MST",
  "America/Inuvik": "MST",
  "America/Mazatlan": "MST",
  "America/Ojinaga": "CST",
  "America/Phoenix": "MST",
  "America/Whitehorse": "MST",
  "America/Yellowknife": "MST",
  "America/Bahia_Banderas": "CST",
  "America/Belize": "CST",
  "America/Chicago": "CST",
  "America/Costa_Rica": "CST",
  "America/El_Salvador": "CST",
  "America/Guatemala": "CST",
  "America/Indiana/Knox": "CST",
  "America/Indiana/Tell_City": "CST",
  "America/Managua": "CST",
  "America/Matamoros": "CST",
  "America/Menominee": "CST",
  "America/Merida": "CST",
  "America/Mexico_City": "CST",
  "America/Monterrey": "CST",
  "America/North_Dakota/Beulah": "CST",
  "America/North_Dakota/Center": "CST",
  "America/North_Dakota/New_Salem": "CST",
  "America/Rainy_River": "CST",
  "America/Rankin_Inlet": "CST",
  "America/Regina": "CST",
  "America/Resolute": "CST",
  "America/Swift_Current": "CST",
  "America/Tegucigalpa": "CST",
  "America/Winnipeg": "CST",
  "America/Atikokan": "EST",
  "America/Cancun": "EST",
  "America/Cayman": "EST",
  "America/Detroit": "EST",
  "America/Grand_Turk": "EST",
  "America/Havana": "CST",
  "America/Indiana/Indianapolis": "EST",
  "America/Indiana/Marengo": "EST",
  "America/Indiana/Petersburg": "EST",
  "America/Indiana/Vevay": "EST",
  "America/Indiana/Vincennes": "EST",
  "America/Indiana/Winamac": "EST",
  "America/Iqaluit": "EST",
  "America/Jamaica": "EST",
  "America/Kentucky/Louisville": "EST",
  "America/Kentucky/Monticello": "EST",
  "America/Nassau": "EST",
  "America/New_York": "EST",
  "America/Nipigon": "EST",
  "America/Panama": "EST",
  "America/Pangnirtung": "EST",
  "America/Port-au-Prince": "EST",
  "America/Thunder_Bay": "EST",
  "America/Toronto": "EST",
  "America/Anguilla": "AST",
  "America/Antigua": "AST",
  "America/Aruba": "AST",
  "America/Barbados": "AST",
  "America/Blanc-Sablon": "AST",
  "America/Curacao": "AST",
  "America/Dominica": "AST",
  "America/Glace_Bay": "AST",
  "America/Goose_Bay": "AST",
  "America/Grenada": "AST",
  "America/Guadeloupe": "AST",
  "America/Halifax": "AST",
  "America/Kralendijk": "AST",
  "America/Lower_Princes": "AST",
  "America/Marigot": "AST",
  "America/Martinique": "AST",
  "America/Moncton": "AST",
  "America/Montserrat": "AST",
  "America/Port_of_Spain": "AST",
  "America/Puerto_Rico": "AST",
  "America/Santo_Domingo": "AST",
  "America/St_Barthelemy": "AST",
  "America/St_Kitts": "AST",
  "America/St_Lucia": "AST",
  "America/St_Thomas": "AST",
  "America/St_Vincent": "AST",
  "America/Thule": "AST",
  "America/Tortola": "AST",
  "Atlantic/Bermuda": "AST",
  "America/St_Johns": "NST",
  "Africa/Abidjan": "GMT",
  "Africa/Accra": "GMT",
  "Africa/Bamako": "GMT",
  "Africa/Banjul": "GMT",
  "Africa/Bissau": "GMT",
  "Africa/Conakry": "GMT",
  "Africa/Dakar": "GMT",
  "Africa/Freetown": "GMT",
  "Africa/Lome": "GMT",
  "Africa/Monrovia": "GMT",
  "Africa/Nouakchott": "GMT",
  "Africa/Ouagadougou": "GMT",
  "Africa/Sao_Tome": "GMT",
  "America/Danmarkshavn": "GMT",
  "Atlantic/Canary": "WET",
  "Atlantic/Faroe": "WET",
  "Atlantic/Madeira": "WET",
  "Atlantic/Reykjavik": "GMT",
  "Atlantic/St_Helena": "GMT",
  "Europe/Dublin": "GMT",
  "Europe/Guernsey": "GMT",
  "Europe/Isle_of_Man": "GMT",
  "Europe/Jersey": "GMT",
  "Europe/Lisbon": "WET",
  "Europe/London": "GMT",
  "Africa/Algiers": "CET",
  "Africa/Bangui": "WAT",
  "Africa/Brazzaville": "WAT",
  "Africa/Ceuta": "CET",
  "Africa/Douala": "WAT",
  "Africa/Kinshasa": "WAT",
  "Africa/Lagos": "WAT",
  "Africa/Libreville": "WAT",
  "Africa/Luanda": "WAT",
  "Africa/Malabo": "WAT",
  "Africa/Ndjamena": "WAT",
  "Africa/Niamey": "WAT",
  "Africa/Porto-Novo": "WAT",
  "Africa/Tunis": "CET",
  "Africa/Windhoek": "CAT",
  "Arctic/Longyearbyen": "CET",
  "Europe/Amsterdam": "CET",
  "Europe/Andorra": "CET",
  "Europe/Belgrade": "CET",
  "Europe/Berlin": "CET",
  "Europe/Bratislava": "CET",
  "Europe/Brussels": "CET",
  "Europe/Budapest": "CET",
  "Europe/Copenhagen": "CET",
  "Europe/Gibraltar": "CET",
  "Europe/Ljubljana": "CET",
  "Europe/Luxembourg": "CET",
  "Europe/Madrid": "CET",
  "Europe/Malta": "CET",
  "Europe/Monaco": "CET",
  "Europe/Oslo": "CET",
  "Europe/Paris": "CET",
  "Europe/Podgorica": "CET",
  "Europe/Prague": "CET",
  "Europe/Rome": "CET",
  "Europe/San_Marino": "CET",
  "Europe/Sarajevo": "CET",
  "Europe/Skopje": "CET",
  "Europe/Stockholm": "CET",
  "Europe/Tirane": "CET",
  "Europe/Vaduz": "CET",
  "Europe/Vatican": "CET",
  "Europe/Vienna": "CET",
  "Europe/Warsaw": "CET",
  "Europe/Zagreb": "CET",
  "Europe/Zurich": "CET",
  "Africa/Blantyre": "CAT",
  "Africa/Bujumbura": "CAT",
  "Africa/Cairo": "EET",
  "Africa/Gaborone": "CAT",
  "Africa/Harare": "CAT",
  "Africa/Johannesburg": "SAST",
  "Africa/Juba": "CAT",
  "Africa/Khartoum": "CAT",
  "Africa/Kigali": "CAT",
  "Africa/Lubumbashi": "CAT",
  "Africa/Lusaka": "CAT",
  "Africa/Maputo": "CAT",
  "Africa/Maseru": "SAST",
  "Africa/Mbabane": "SAST",
  "Africa/Tripoli": "EET",
  "Asia/Beirut": "EET",
  "Asia/Famagusta": "EET",
  "Asia/Gaza": "EET",
  "Asia/Hebron": "EET",
  "Asia/Jerusalem": "IST",
  "Asia/Nicosia": "EET",
  "Europe/Athens": "EET",
  "Europe/Bucharest": "EET",
  "Europe/Chisinau": "EET",
  "Europe/Helsinki": "EET",
  "Europe/Kaliningrad": "EET",
  "Europe/Kyiv": "EET",
  "Europe/Mariehamn": "EET",
  "Europe/Riga": "EET",
  "Europe/Sofia": "EET",
  "Europe/Tallinn": "EET",
  "Europe/Uzhgorod": "EET",
  "Europe/Vilnius": "EET",
  "Europe/Zaporizhzhia": "UTC",
  "Africa/Addis_Ababa": "EAT",
  "Africa/Asmara": "EAT",
  "Africa/Dar_es_Salaam": "EAT",
  "Africa/Djibouti": "EAT",
  "Africa/Kampala": "EAT",
  "Africa/Mogadishu": "EAT",
  "Africa/Nairobi": "EAT",
  "Indian/Antananarivo": "EAT",
  "Indian/Comoro": "EAT",
  "Indian/Mayotte": "EAT",
  "Europe/Kirov": "MSK",
  "Europe/Moscow": "MSK",
  "Europe/Simferopol": "MSK",
  "Europe/Volgograd": "MSK",
  "Asia/Karachi": "PKT",
  "Asia/Kolkata": "IST",
  "Asia/Jakarta": "WIB",
  "Asia/Pontianak": "WIB",
  "Asia/Hong_Kong": "HKT",
  "Asia/Macau": "CST",
  "Asia/Makassar": "WITA",
  "Asia/Manila": "PST",
  "Asia/Shanghai": "CST",
  "Asia/Taipei": "CST",
  "Australia/Perth": "AWST",
  "Asia/Jayapura": "WIT",
  "Asia/Pyongyang": "KST",
  "Asia/Seoul": "KST",
  "Asia/Tokyo": "JST",
  "Australia/Adelaide": "ACDT",
  "Australia/Broken_Hill": "ACDT",
  "Australia/Darwin": "ACST",
  "Antarctica/Macquarie": "AEDT",
  "Australia/Brisbane": "AEST",
  "Australia/Currie": "AEDT",
  "Australia/Hobart": "AEDT",
  "Australia/Lindeman": "AEST",
  "Australia/Melbourne": "AEDT",
  "Australia/Sydney": "AEDT",
  "Pacific/Guam": "ChST",
  "Pacific/Saipan": "ChST",
  "Antarctica/McMurdo": "NZDT",
  "Pacific/Auckland": "NZDT"
}